import api from './interceptor'
import apiEW from './interceptorEW'

export const getDealers = params => {
  return api.get('/basis/getDealers', { params })
}
export const getSeriesModels = params => {
  return api.get('/basis/productManagement/getSeriesModels', { params })
}
export const getCarAge = params => {
  return api.get('/car/carAge/getList', { params })
}
export const getProvinceCity = params => {
  return api.get('/basis/getProvince', { params })
}
export const getPlanList = params => {
  return api.get('/loyalty/plan/getLoyaltyPlanList', { params })
}

// 获取致友计划详情信息
export const getPlanDetail = params => {
  return api.get('/loyalty/plan/getPlanDetails', { params })
}

// 获取计划的默认经销商
export const getDefaultDealersByloyaltyId = params => {
  return api.get('/loyalty/plan/getPlanDetails', { params })
}

// 获取计划的使用经销商
export const getUseDealersByloyaltyId = params => {
  return api.get('/loyalty/plan/getLoyaltyApplyDealerDetails', { params })
}

// 获取计划类型--订单/卡券的使用经销商
export const getUseDealersByloyaltyOrderId = params => {
  return api.get('/loyalty/plan/getLoyaltyApplyDealerDetailsOrder', { params })
}

// 首页搜索-计划搜索列表
export const getLoyaltyPlanListByKeyword = params => {
  return api.get('/loyalty/plan/search', { params })
}

// 计算致友计划价格
export const getLoyaltyPlanPrice = params => {
  return api.get('/loyalty/plan/getLoyaltyPlanPrice', { params })
}

// 我的致友计划列表
export const getMyPlanList = (data = {}) => {
  let params = {
    ...data,
    pageNo: 1,
    pageSize: 10000
  }
  return apiEW.get('/occ/order/as/aggregator/client/v1/mall/coupons', { params })
}

// 判断经销商是否参与某个计划
export const checkDealerJoin = params => {
  return api.get('/loyalty/plan/checkDealerJoin', { params })
}
